import { Button, Classes, H6 } from '@blueprintjs/core';
import React from 'react';
import DateRangePickerComponent from '../providersView/dateRangePickerComponent';
import { advancedFilters, dateRangePickerContainerAdvanced, firstLabelStyle, labelStyleFitContent, labelStyle, filterStyle, flexRowCenter } from '../../styles';
import ProviderDropdown from '../dropdownComponents/providerDropdown';

export default class AdvancedFilters extends React.Component {
    render() {
        return (
            <div style={advancedFilters(this.props.themeName === Classes.DARK)}>
                <div style={flexRowCenter}>
                    <div style={dateRangePickerContainerAdvanced}>
                        <div style={firstLabelStyle}>
                            <H6>Dates</H6>
                        </div>
                        <DateRangePickerComponent
                            dateRange={[this.props.values.dueTimeAfterTripLocalTime, this.props.values.dueTimeBeforeTripLocalTime]}
                            onChange={this.props.handleDateRangeChange}
                        />
                    </div>
                    <div style={labelStyleFitContent}>
                        <H6>Passenger ID</H6>
                    </div>
                    <input
                        className="bp3-input .modifier"
                        name="alcPassengerId"
                        onChange={this.props.handleSearchOptionsChange}
                        value={this.props.values.alcPassengerId}
                        type="text"
                        placeholder="Search..."
                        dir="auto"
                    />
                    <div style={labelStyleFitContent}>
                        <H6>First Name</H6>
                    </div>
                    <input
                        className="bp3-input .modifier"
                        name="firstName"
                        onChange={this.props.handleSearchOptionsChange}
                        value={this.props.values.firstName}
                        type="text"
                        dir="auto"
                    />
                    <div style={labelStyleFitContent}>
                        <H6>Last Name</H6>
                    </div>
                    <input
                        className="bp3-input .modifier"
                        name="lastName"
                        onChange={this.props.handleSearchOptionsChange}
                        value={this.props.values.lastName}
                        type="text"
                        dir="auto"
                    />
                </div>
                <div style={{ display: 'flex', paddingTop: '0.5rem' }}>
                    <div style={{ width: '400px', display: 'flex' }}>
                        <div style={firstLabelStyle}>
                            <H6>Service Provider</H6>
                        </div>
                        <div style={{width: "280px"}}>
                        <ProviderDropdown
                            providers={this.props.providers}
                            selectedProvider={this.props.selectedProvider}
                            disabled={this.props.disableProviderDropdown}
                            handleProviderChange={this.props.handleProviderChange}
                            isMulti={true}
                            isClearable={true}
                        />
                        </div>
                    </div>
                    <div style={labelStyle}>
                        <H6>City</H6>
                    </div>
                    <input
                        className="bp3-input .modifier"
                        name="city"
                        onChange={this.props.handleSearchOptionsChange}
                        value={this.props.values.city}
                        type="text"
                        dir="auto"
                    />
                    <div style={labelStyle}>
                        <H6>Status</H6>
                    </div>

                    <select
                        value={this.props.tripStatus}
                        onChange={this.props.handleChange}
                        className='bp3-input .modifier'
                        
                    >
                        <option className={localStorage.getItem("themeName") ? 'options-dark-theme2 bp3-input .modifier' : 'bp3-input .modifier'} value={''}>All</option>
                        {this.props.tripStatusArray.map((status, i) => {
                            return <option key={i} className={localStorage.getItem("themeName") ? 'options-dark-theme2 bp3-input .modifier' : 'bp3-input .modifier'} value={status.value}>{status.value}</option>
                        })}
                    </select>

                    <div style={filterStyle}>
                        <Button
                            text='Filter'
                            icon='filter'
                            intent={'primary'}
                            onClick={() => this.props.filter(0)}
                        />
                    </div>
                </div>
            </div>
        )
    }
}
